module.exports = __webpack_public_path__ + "static/img/200216.ffa44cbc.png";